export default (previousState = 0, { type, payload }) => {
    return previousState;
}



// WEBPACK FOOTER //
// ./src/reducer.js